<span style="text-align: right">{{ value }}</span>
